import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute()

// 判断是否为外部链接
const isExternalLink = (path: string): boolean => {
  return /^(https?:|mailto:|tel:)/.test(path)
}

onMounted(() => {
  const { path } = route.params
  const decodedPath = decodeURIComponent(path as string)
  
  if (isExternalLink(decodedPath)) {
    // 如果是外部链接，直接打开
    window.open(decodedPath, '_blank')
    // 如果需要在当前窗口打开，可以使用下面的代码
    // window.location.href = decodedPath
  } else {
    // 如果是内部路径，重定向到该路径
    window.location.href = decodedPath
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, "重定向中..."))
}
}

})